import React from "react";
import useTaskTags from "../hooks/useTaskTags";

// Component for rendering task tag checkboxes
function TaskTags({ task, tags, useTags, onUpdateTask }) {
  const { handleTagToggle } = useTaskTags(task, onUpdateTask);

  if (!useTags || !tags || tags.length === 0) return null;

  return (
    <div className="tag-checkboxes">
      {tags.map((tag) => (
        <label key={tag} className="tag-checkbox-label">
          <input
            type="checkbox"
            checked={(task.tags || []).includes(tag)}
            onChange={() => handleTagToggle(tag)}
            onClick={(e) => e.stopPropagation()}
          />
          {tag}
        </label>
      ))}
    </div>
  );
}

export default TaskTags;
